import axios from 'axios'
let baseEndpoint = ''
if (process.env.NODE_ENV === 'development') {
    baseEndpoint = process.env.VUE_APP_BASE_URL_DEV
} else {
    baseEndpoint = '/api'
}
// baseEndpoint ="http://496fa5ad4dc8.ngrok.io/api";
const resource = '/authenticate/';

export default {
  login(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${baseEndpoint}${resource}login`, payload)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  changePassword(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${baseEndpoint}${resource}change_password`, payload)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  logout() {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/logout`, {})
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};
